import { HEADING_COLOR, type BlockComponentProps } from "./shared"

export function FundraisingGoalBlock({ content, resolved }: BlockComponentProps) {
  const fh = (content?.heading as string) ?? ""
  const goal = (content?.goal_amount as number) ?? 0
  const raised = (content?.raised_amount as number) ?? 0
  const currency = (content?.currency as string) ?? "USD"
  const label = (content?.label as string) ?? "raised"
  const ctaText = (content?.cta_text as string) ?? ""
  const ctaUrl = (content?.cta_url as string) ?? ""
  const primaryColor = "var(--nos-color-primary, #3b82f6)"
  const pct = goal > 0 ? Math.min(100, (raised / goal) * 100) : 0
  const fgSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8"
  return (
    <section className={fgSectionClass} style={resolved.sectionStyle}>
      <div className="max-w-xl mx-auto rounded-xl border bg-card p-6">
        {fh && (
          <h2 className="text-xl font-bold mb-4" style={{ color: HEADING_COLOR }}>
            {fh}
          </h2>
        )}
        <div className="mb-2 flex justify-between text-sm">
          <span>
            {new Intl.NumberFormat(undefined, {
              style: "currency",
              currency: currency,
            }).format(raised)}{" "}
            {label}
          </span>
          <span className="text-muted-foreground">
            {new Intl.NumberFormat(undefined, {
              style: "currency",
              currency: currency,
            }).format(goal)}{" "}
            goal
          </span>
        </div>
        <div className="h-3 rounded-full bg-muted overflow-hidden">
          <div
            className="h-full rounded-full transition-all"
            style={{ width: `${pct}%`, backgroundColor: primaryColor }}
          />
        </div>
        {ctaText && ctaUrl && (
          <a
            href={ctaUrl}
            className="inline-block mt-4 px-4 py-2 rounded-lg font-medium text-white"
            style={{ backgroundColor: primaryColor }}
          >
            {ctaText}
          </a>
        )}
      </div>
    </section>
  )
}
